import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Select } from "antd";
import AxiosInstance from "../../../AxiosInstance";

import { Controller, useForm } from "react-hook-form";
import { useMediaQuery } from "react-responsive";
import OtherPageHeader from "../../../components/OtherHeader";
import { TPEProfile } from "../../../svg/SvgImages";
import { Option } from "antd/es/mentions";
import {
  banksListController,
  countriesListController,
  insurerListController,
  statesListController,
} from "../../Helper/provider";
import { alertError } from "../../Helper/Alerts";
import { uploadProfileDocumentToAWS } from "../../Helper/uploadDocument";
import { getBankAccountType } from "../../../utils";
const PartnerRegistraion = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    reset,
  } = useForm({ mode: "onChange" });
  const navigate = useNavigate();
  const [panDoc, setpanDoc] = useState();
  const [aadharDoc, setaadharDoc] = useState();
  const [cancelledChecqDoc, setcancelledChecqDoc] = useState();
  const [insurer, setInsurer] = useState([]);
  const [countries, setCountries] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [existingUser, setExistingUser] = useState(false);
  const { state } = useLocation();
  // const isMobile = useMediaQuery({ query: "(max-width: 750px)" });

  useEffect(() => {
    getSpinnerData();
    console.log(state);
    if (state && state.payload) {
      setExistingUser(true);
      setValue("pan", state.payload.pan);
      setValue("aadhar", state.payload.aadhar);
      setValue("gender", state.payload.gender);
      setValue("address", state.payload.address);
      setValue("city", state.payload.city);
      setValue("pinCode", state.payload.pinCode);
      setValue("occupation", state.payload.occupation);
      setValue("bankAccountNumber", state.payload.bankAccountNumber);
      setValue("UPICode", state.payload.UPICode);
      setValue("IFSCCode", state.payload.IFSCCode);

      setValue("countryId", state.payload.countryId);
      setValue("stateId", state.payload.stateId);
      setValue("bankId", state.payload.bankId);
      setValue("accountType", state.payload.accountType);
      setValue("CKYCNumber", state.payload.CKYCNumber);
    }
  }, []);
  const getSpinnerData = async () => {
    const result = await insurerListController(true);
    setInsurer(result);
    const ctn = await countriesListController();
    setCountries(ctn);
    const bnk = await banksListController();
    setBankList(bnk);
    if (state?.payload) {
      const list = await statesListController(state.payload.countryId);
      setStateList(list);
    }
  };
  async function handleDocument(event, target) {
    switch (target) {
      case "panDocument":
        setpanDoc(event.target.files[0]);
        break;
      case "aadharDocument":
        setaadharDoc(event.target.files[0]);
        break;
      default:
        setcancelledChecqDoc(event.target.files[0]);
        break;
    }
  }

  async function uploadDocumentToAWS(file) {
    const url = "/common/upload-policy-document";
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    try {
      let response = await AxiosInstance().post(url, formData, config);
      return response.data["policyContractFileName"];
    } catch (e) {
      return "";
    }
  }
  const genderChange = (value) => {
    errors.gender = false;
    setValue("gender", value);
  };
  const insurerChange = (insurerId) => {
    errors.insurerId = false;
    setValue("insurerId", parseInt(insurerId));
  };

  const countryChange = async (countryID) => {
    errors.countryId = false;
    setValue("countryId", parseInt(countryID));
    const list = await statesListController(countryID);
    setStateList(list);
  };
  const stateChange = (stateId) => {
    errors.stateId = false;
    setValue("stateId", parseInt(stateId));
  };
  const bankNameChange = (value) => {
    errors.bankId = false;
    setValue("bankId", parseInt(value));
  };
  const accountTypeChange = (type) => {
    errors.accountType = false;
    setValue("accountType", type);
  };
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });

  const onSubmit = async (value) => {
    console.log("Values.before upload..", value);
    const id = localStorage.getItem("id");
    if (panDoc)
      value.PANDocument = await uploadProfileDocumentToAWS(panDoc, id);
    if (aadharDoc)
      value.AADHARDocument = await uploadProfileDocumentToAWS(aadharDoc, id);
    if (cancelledChecqDoc)
      value.cancelledCheck = await uploadProfileDocumentToAWS(
        cancelledChecqDoc,
        id
      );

    console.log("Values after upload...", value);
    if (existingUser) {
      AxiosInstance()
        .post("/auth/addNewRole", { userRole: "PARTNER" })
        .then((resp) => {
          localStorage.setItem("token", resp.data.token);
          AxiosInstance()
            .put("/profile", value)
            .then((resp) => {
              window.location.href = "/partnerDashboard";
            })
            .catch((err) => {
              alertError(err?.response?.data?.message);
            });
        })
        .catch((err) => {
          alertError(err?.response?.data?.message);
        });
      return;
    }
    AxiosInstance()
      .put("/profile", value)
      .then((resp) => {
        let { data } = resp;
        // localStorage.setItem("token", data.token);
        window.location.href = "/partnerDashboard";
      })
      .catch((err) => {
        alertError(err?.response?.data?.message);
      });
  };
  const options = [
    {
      value: "MALE",
      label: "Male",
    },
    {
      value: "FEMALE",
      label: "Female",
    },

    {
      value: "OTHERS",
      label: "Others",
    },
  ];

  return (
    <div>
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="navbar-light"
      />
      <section className="section-preview py-3">
        <div className="container">
          <div className="row mx-1">
            {!isMobile && (
              <div className="col-md-5 mb-4 px-4 d-none d-md-block">
                <TPEProfile />
              </div>
            )}
            <div className="col-md-7 mb-4 px-4">
              <div className="common-width">
                <button
                  type="submit"
                  title="back-button"
                  className="back-button"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {" "}
                  <i className="fa fa-angle-left" /> Back
                </button>
                <h2 className="partner-complete-profile">
                  Complete your Profile
                </h2>
                <form
                  id="completePartnerDetails"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div class="row my-3 ">
                    <h4 className="font-20 tre_font-bold">Personal Details</h4>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="insurer" class="">
                          Working With {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <Controller
                          name="insurerId"
                          control={control}
                          errors={errors}
                          rules={{ required: true }}
                          render={(props) => (
                            <Select
                              className={`${
                                errors.insurerId ? "is-invalid" : ""
                              }`}
                              placeholder="Select Insurer"
                              onChange={insurerChange}
                              size="large"
                              style={{ width: "100%" }}
                            >
                              {insurer.map((item) => (
                                <Option
                                  key={item.insurerId}
                                  value={item.insurerId}
                                >
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                          )}
                        />

                        <div className="invalid-feedback">
                          Insurer is required
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 md-form">
                      <label htmlFor="firstName">
                        Gender {<span style={{ color: "red" }}>*</span>}
                      </label>

                      <div className="input-group">
                        <Controller
                          name="gender"
                          control={control}
                          errors={errors}
                          rules={{ required: true }}
                          render={({ field: { onChange, value, ref } }) => (
                            <Select
                              disabled={state?.payload?.gender}
                              value={getValues("gender")}
                              onChange={genderChange}
                              size="large"
                              className={`${errors.gender ? "is-invalid" : ""}`}
                              options={options}
                              style={{ width: "100%" }}
                            />
                          )}
                        />

                        <div className="invalid-feedback">
                          Gender is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="pan" class="">
                          PAN No. {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                          disabled={state?.payload?.pan}
                          type="text"
                          id="pan"
                          name="pan"
                          className={`form-control ${
                            errors.pan ? " is-invalid" : ""
                          }`}
                          {...register("pan", {
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">Pan is required</div>
                      </div>
                    </div>
                    <div class="col-md-6 md-form">
                      <label for="occupation" class="">
                        Occupation {<span style={{ color: "red" }}>*</span>}
                      </label>
                      <input
                        disabled={state?.payload?.occupation}
                        type="text"
                        id="occupation"
                        name="occupation"
                        className={`form-control ${
                          errors.occupation ? " is-invalid" : ""
                        }`}
                        {...register("occupation", {
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        Occupation is required
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="aadhar" class="">
                          Aadhar No. {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                          disabled={state?.payload?.aadhar}
                          type="text"
                          id="aadhar"
                          name="aadhar"
                          className={`form-control ${
                            errors.aadhar ? " is-invalid" : ""
                          }`}
                          {...register("aadhar", {
                            required: true,
                            pattern: {
                              value: /^[0-9]*$/i,
                              message: "invalid value",
                            },
                          })}
                        />
                        <div className="invalid-feedback">
                          Aadhar is required
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="address" class="">
                          Current Address{" "}
                          {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                          type="text"
                          id="address"
                          name="address"
                          disabled={state?.payload?.address}
                          className={`form-control ${
                            errors.address ? " is-invalid" : ""
                          }`}
                          {...register("address", {
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          Address is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="countryId" class="">
                          Country {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <Controller
                          name="countryId"
                          control={control}
                          errors={errors}
                          rules={{ required: true }}
                          render={(props) => (
                            <Select
                              className={`${
                                errors.countryId ? "is-invalid" : ""
                              }`}
                              disabled={state?.payload?.countryId}
                              value={getValues("countryId")}
                              onChange={countryChange}
                              size="large"
                              style={{ width: "100%" }}
                            >
                              {countries.map((item) => (
                                <Option
                                  key={item.countryId}
                                  value={item.countryId}
                                >
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                          )}
                        />

                        <div className="invalid-feedback">
                          Country is required
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="state" class="">
                          State {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <Controller
                          name="stateId"
                          control={control}
                          errors={errors}
                          rules={{ required: true }}
                          render={(props) => (
                            <Select
                              className={`${
                                errors.stateId ? "is-invalid" : ""
                              }`}
                              disabled={state?.payload?.stateId}
                              value={getValues("stateId")}
                              onChange={stateChange}
                              size="large"
                              style={{ width: "100%" }}
                            >
                              {stateList.map((item) => (
                                <Option key={item.stateId} value={item.stateId}>
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                          )}
                        />

                        <div className="invalid-feedback">
                          State is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="city" class="">
                          City {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                          disabled={state?.payload?.city}
                          type="text"
                          id="city"
                          name="city"
                          className={`form-control ${
                            errors.city ? " is-invalid" : ""
                          }`}
                          {...register("city", {
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">City is required</div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="pinCode" class="">
                          Pin Code {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                          disabled={state?.payload?.pinCode}
                          type="text"
                          id="pinCode"
                          name="pinCode"
                          className={`form-control ${
                            errors.pinCode ? " is-invalid" : ""
                          }`}
                          {...register("pinCode", {
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          Pincode is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="md-form">
                        {/* <label for="trePartnerpAddress" class="">
                          Parmanent Address
                        </label>
                        <input
                          type="text"
                          id="trePartnerpAddress"
                          name="trePartnerpAddress"
                          class="form-control"
                        /> */}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="md-form"></div>
                    </div>
                  </div>
                  <div class="row my-3">
                    <h4 className="font-20 tre_font-bold">Banking Details</h4>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="bankAccountNumber" class="">
                          Bank Account Number{" "}
                          {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                          disabled={state?.payload?.bankAccountNumber}
                          type="text"
                          id="bankAccountNumber"
                          placeholder=""
                          className={`form-control ${
                            errors.bankAccountNumber ? " is-invalid" : ""
                          }`}
                          {...register("bankAccountNumber", {
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          Account Number is required
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="md-form">
                        <label htmlFor="bankName">
                          Bank Name {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <div className="input-group">
                          <Controller
                            name="bankId"
                            control={control}
                            errors={errors}
                            rules={{ required: true }}
                            render={(props) => (
                              <Select
                                className={`${
                                  errors.bankId ? "is-invalid" : ""
                                }`}
                                disabled={state?.payload?.bankId}
                                value={getValues("bankId")}
                                onChange={bankNameChange}
                                size="large"
                                style={{ width: "100%" }}
                              >
                                {bankList.map((item) => (
                                  <Option key={item.bankId} value={item.bankId}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                            )}
                          />

                          <div className="invalid-feedback">
                            Bank Name is required
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="md-form">
                        <label htmlFor="accountType">
                          Account Type {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <Controller
                          name="accountType"
                          control={control}
                          errors={errors}
                          rules={{ required: true }}
                          render={(props) => (
                            <Select
                              className={`${
                                errors.accountType ? "is-invalid" : ""
                              }`}
                              disabled={state?.payload?.accountType}
                              value={getValues("accountType")}
                              onChange={accountTypeChange}
                              size="large"
                              style={{ width: "100%" }}
                            >
                              {getBankAccountType()}
                            </Select>
                          )}
                        />

                        <div className="invalid-feedback">
                          Account Type is required
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="CKYCNumber" class="">
                          CKYC No.
                        </label>
                        <input
                          disabled={state?.payload?.CKYCNumber}
                          type="text"
                          id="CKYCNumber"
                          className={`form-control ${
                            errors.CKYCNumber ? " is-invalid" : ""
                          }`}
                          name="CKYCNumber"
                          {...register("CKYCNumber", {})}
                        />
                      </div>
                      {/* <div class="md-form">
                        <label htmlFor="MICR ">MICR</label>
                        <input
                          type="text"
                          id="MICR"
                          name="MICR"
                          className={`form-control ${
                            errors.MICR ? " is-invalid" : ""
                          }`}
                          {...register("MICR", {
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          MICR Code is required
                        </div>
                      </div> */}
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="IFSCCode" class="">
                          IFSC Code {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                          disabled={state?.payload?.IFSCCode}
                          type="text"
                          id="IFSCCode"
                          name="IFSCCode"
                          className={`form-control ${
                            errors.IFSCCode ? " is-invalid" : ""
                          }`}
                          {...register("IFSCCode", {
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          IFSC Code is required
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="md-form">
                        <label for="UPICode" class="">
                          UPI Id
                        </label>
                        <input
                          disabled={state?.payload?.UPICode}
                          type="text"
                          id="UPICode"
                          name="UPICode"
                          class="form-control"
                          {...register("UPICode", {})}
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6"></div>
                    <div class="col-md-6">
                      {/* <div class="md-form">
                        <label for="EIANumber" class="">
                          EIA No.
                        </label>
                        <input
                          type="text"
                          id="EIANumber"
                          name="EIANumber"
                          class="form-control"
                          {...register("EIANumber", {})}
                        />
                      </div> */}
                    </div>
                  </div>

                  <div class="row my-3">
                    <h4 className="font-20 tre_font-bold">Attachment Doc</h4>
                  </div>

                  {!state?.payload.PANDocument && (
                    <div className="mb-3 mt-2">
                      <label htmlFor="formFile" className="form-label">
                        Upload Pan
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        id="panDocument"
                        onChange={(event) => {
                          handleDocument(event, "panDocument");
                        }}
                      />
                    </div>
                  )}

                  {!state?.payload.AADHARDocument && (
                    <div className="mb-3">
                      <label htmlFor="formFile" className="form-label">
                        Upload Aadhar
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        id="aadharDocument"
                        onChange={(event) => {
                          handleDocument(event, "aadharDocument");
                        }}
                      />
                    </div>
                  )}
                  {!state?.payload.cancelledCheck && (
                    <div className="mb-3">
                      <label htmlFor="cancelledCheck" className="form-label">
                        Upload Cancelled Cheque
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        id="cancelledCheck"
                        onChange={(event) => {
                          handleDocument(event, "");
                        }}
                      />
                    </div>
                  )}
                </form>
                <button
                  className="btn-block btn-holder btn-md mb-5"
                  form="completePartnerDetails"
                >
                  Complete Profile
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartnerRegistraion;
